import { render, staticRenderFns } from "./InputfieldTextarea.vue?vue&type=template&id=ab5e2bc4&scoped=true&"
import script from "./InputfieldTextarea.vue?vue&type=script&lang=js&"
export * from "./InputfieldTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5e2bc4",
  null
  
)

export default component.exports